import { useCallback, useContext } from 'react'

import { FrameBuilderSelectionContext } from '@frame-builder/contexts/selection-context'
import { FrameBuilderStringsContext } from '@frame-builder/contexts/strings-context'
import { FrameBuilderValidationContext } from '@frame-builder/contexts/validation-context'
import { type StepPreviewProps } from '@frame-builder/lib/steps'

import ConfigurationStepPreview from './configuration-step-preview'

const PassepartoutStepPreview = ({
  stepNumber,
  openStep,
  onToggleStep,
}: StepPreviewProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { committedStateSelectionMessages } = useContext(
    FrameBuilderSelectionContext,
  )
  const { stepPreviewAnimation, validationErrorMessages } = useContext(
    FrameBuilderValidationContext,
  )

  const handleClick = useCallback(() => {
    const isStepOpen = openStep === 'passepartout'
    onToggleStep('passepartout', !isStepOpen)
  }, [onToggleStep, openStep])

  return (
    <ConfigurationStepPreview
      title={frameBuilderStrings.passepartoutStepTitle}
      value={committedStateSelectionMessages?.passepartout}
      error={
        validationErrorMessages?.passepartoutColorPreview ??
        validationErrorMessages?.passepartoutSizePreview
      }
      placeholder={frameBuilderStrings.passepartoutPlaceholder}
      opacity={stepPreviewAnimation.passepartoutOpacity}
      stepNumber={stepNumber}
      onClick={handleClick}
      className="grow-0 shrink-0"
    />
  )
}

export default PassepartoutStepPreview
